import { render, staticRenderFns } from "./EventTheme.vue?vue&type=template&id=7e90a973&scoped=true"
import script from "./EventTheme.vue?vue&type=script&lang=ts"
export * from "./EventTheme.vue?vue&type=script&lang=ts"
import style0 from "./EventTheme.vue?vue&type=style&index=0&id=7e90a973&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e90a973",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e90a973')) {
      api.createRecord('7e90a973', component.options)
    } else {
      api.reload('7e90a973', component.options)
    }
    module.hot.accept("./EventTheme.vue?vue&type=template&id=7e90a973&scoped=true", function () {
      api.rerender('7e90a973', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/EventTheme.vue"
export default component.exports